import request from '@/utils/request';

export function getList(data) {
  return request({
    url: '/dBConnections/load',
    method: 'post',
    data
  });
}

export function loadForRole(roleId) {
  return request({
    url: '/dBConnections/loadForRole',
    method: 'get',
    params: { appId: '', firstId: roleId }
  });
}

export function add(data) {
  return request({
    url: '/dBConnections/add',
    method: 'post',
    data
  });
}

export function update(data) {
  return request({
    url: '/dBConnections/update',
    method: 'post',
    data
  });
}

export function del(data) {
  return request({
    url: '/dBConnections/delete',
    method: 'post',
    data
  });
}

export function get(id) {
  return request({
    url: '/dBConnections/Get',
    method: 'get',
    params: { id: id }
  });
}

export function getloadfile(data) {
  return request({
    url: '/dBConnections/GetLoadFile',
    method: 'post',
    responseType: 'arraybuffer',
    data
  });
}
